import type { TanStackFormLike, ZodLikeIssue } from './tanstackFormZod';
import { pushZodIssuesToTanStackForm } from './tanstackFormZod';

interface ValidateResult<T> {
  success: boolean;
  data?: T;
  error?: { issues: ReadonlyArray<ZodLikeIssue> };
}

/**
 * Run a Zod-backed validateDraft and either return the parsed data
 * or push field-level errors into the TanStack form.
 */
export function commitOrPushErrors<T>(form: TanStackFormLike, result: ValidateResult<T>): T | null {
  if (result.success && result.data !== undefined) {
    return result.data;
  }
  if (result.error) {
    pushZodIssuesToTanStackForm(form, result.error.issues);
  }
  return null;
}
